import { Injectable } from '@angular/core'
import { MediaObserver } from '@ngbracket/ngx-layout'

@Injectable({ providedIn: 'root' })
export class MediaService extends MediaObserver {

    /** For screen width < 960px */
    get isMobile(): boolean {
        return super.isActive('lt-md');
    }

    /** For screen width >= 960px */
    get isDesktop(): boolean {
        return super.isActive('gt-sm');
    } 

    getFullHdRelativeWidth(factor:number): number {
        return Math.min(window.screen.width, 1920) * factor;
    }

    getFullHdRelativeHeight(factor:number): number {
        return Math.min(window.screen.height, 1080) * factor;
    }
}
